import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PrimeNG } from 'primeng/config';
import { StateService } from './services/other/state';
import { ChangeLangService } from './services/other/change-lang';
import { ToastModule } from 'primeng/toast';
import { NgClass } from '@angular/common';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ButtonModule } from 'primeng/button';
import { SwitchThemeService } from './services/other/switch-theme';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { SessionService } from './services/other/session';
import { HttpInterceptorService } from './services/other/http-interceptor';
import { VersionCheckService } from './services/other/version-check.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    ConfirmDialogModule,
    NgClass,
    ToastModule,
    ButtonModule,
    FormsModule,
    DialogModule,
    TranslateModule,
  ],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App implements OnInit {
  themeService = inject(SwitchThemeService);
  primeng = inject(PrimeNG);
  stateService = inject(StateService);
  cls = inject(ChangeLangService);
  sessionService = inject(SessionService);
  private httpInterceptor = inject(HttpInterceptorService);
  versionCheck = inject(VersionCheckService);

  ngOnInit(): void {
    document.documentElement.style.fontSize = `${'12'}px`;
    this.primeng.ripple.set(true);
    this.primeng.inputVariant.set('filled');
    this.setLang();
    this.setTheme();
    this.versionCheck.start();

    // Start proactive token refresh if user already has a session
    if (this.sessionService.getSessionToken() && this.sessionService.getTokenExpiry()) {
      this.httpInterceptor.scheduleProactiveRefresh();
    }
  }

  setTheme() {
    this.themeService.initTheme();
  }

  setLang(): void {
    this.cls.changeLang(
      localStorage.getItem('langCode')
        ? localStorage.getItem('langCode')!
        : 'en',
    );
  }
}
